import React from 'react';

import CurrentWork from '../../../components/CurrentWork';
import PreviousWork from '../../../components/PreviousWork';
import './style.css';

const ProjectsSection = () => {
  return (
    <>
      <CurrentWork />
      <PreviousWork />
    </>
  );
};

export default ProjectsSection;
